import React from 'react';
import PDFModelPage from '../../ModelDetail/PDFModelPage';
import { Page, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    width: '100%',
    flexDirection: 'column',
    backgroundColor: '#ffff',
    padding: 40,
    alignContent: 'center',
  },
  section: {
    marginBottom: 20,
  },
});

// Create Document Component
const PDFCasting = ({ models = [], casting = {} }) => (
  <Document>
    {/* Title Page */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={styles.section}>
        <Text style={{ fontSize: 14, fontWeight: 'bold' }}>
          PDF EXPORT – CASTING: {casting.pool_id}
        </Text>
      </View>
    </Page>

    {/* One page per model with up to 8 images */}
    {models.map((model, index) => {
      return (
        <PDFModelPage model={model}/>
      );
    })}
  </Document>
);

export default PDFCasting;
